'use client';

import cn from 'classnames';
import { useState } from 'react';

import styles from './VideoLazyArticles.module.scss';

import ArticleSimpleList from '@components/Article/ArticleSimpleList';
import { logger } from '@logger';
import { fetchApi, isApiV2Error } from '@utils/api/client';
import { ArticleI } from 'types/article';

interface PropTypes {
  type: 'freemium' | 'premium';
  locale: string;
  baseArticles: ArticleI[];
  initLastDate: number;
  toLoad?: number;
  canFetchMore?: boolean;
  labels: {
    seeMore: string;
  };
}

function VideoPremiumFreemiumLazyArticles({
  type = 'freemium',
  locale = 'en',
  baseArticles = [],
  initLastDate = 0,
  toLoad = 10,
  canFetchMore = true,
  labels,
}: PropTypes) {
  const [articles, setArticles] = useState<ArticleI[]>(baseArticles);
  const [disableFetch, setDisableFetch] = useState<boolean>(!canFetchMore);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [lastDate, setLastDate] = useState<number>(initLastDate);

  const handleSeeMoreClick = async () => {
    if (disableFetch) {
      return;
    }
    setDisableFetch(true);
    setIsLoading(true);

    try {
      const url = `${process.env.NEXT_PUBLIC_API}/videos/${type}/${locale}?showWallOnly=False&lastDate=${lastDate}&limit=${toLoad}`;
      const res = await fetchApi<any>(url);
      setIsLoading(false);

      if (!res.data || res.data.length === 0) {
        setDisableFetch(true);
        return;
      }

      setArticles((prevValue) => [...prevValue, ...res.data]);
      setLastDate(res.data[res.data.length - 1].dateGmt);
      setDisableFetch(!res.data || res.data.length !== toLoad);
    } catch (e) {
      setIsLoading(false);
      setDisableFetch(true);
      // eslint-disable-next-line no-console
      logger.error(e);
      if (isApiV2Error(e)) {
        const status = e.response?.status || 500;
        if (status === 404) {
          setDisableFetch(true);
        }
      }
    }
  };

  return (
    <>
      <div className='container'>
        <ArticleSimpleList articles={articles} className='grid grid-cols-1 gap-x-4 gap-y-6 transition-all lg:grid-cols-2 lg:gap-x-10 ' />
      </div>
      {(!disableFetch || isLoading) && (
        <button
          onClick={() => handleSeeMoreClick()}
          className={cn('mb-16', styles.seeMore)}
          disabled={isLoading}
        >
          {labels.seeMore}
        </button>
      )}
    </>
  );
}

export default VideoPremiumFreemiumLazyArticles;
